'use strict';

var LazyPicture = require('../../js/LazyPicture');
var Backbone = require('backbone'),
  $ = require('jquery'),
  AnimationScroll = Backbone.View.extend({
    initialize: function() {
      this.$body = $('body')
      this.$classFiveYearsOut = $('.FiveYearsOut')
      if (!this.$body.hasClass('call-animation')) {
        this.animationEle()
        $(window).on('scroll resize load', () => {
          this.animationEle()
        })
        this.$body.addClass('call-animation')
      }
    },
    animationEle() {
      const $elems = $('.AnimationItem')
      const offset = window.innerHeight * 4 / 5
      const wintop = $(window).scrollTop()
      const setAnimationClass = 'Set-animation'
      const doneAnimationClass = 'Done-animation'
      let topcoords = null
      $elems.each((_index, ele) => {
        const $elm = $(ele)
        if ($elm.hasClass(setAnimationClass)) {
          return true
        }
        topcoords = $elm.offset().top
        if (wintop > (topcoords - offset)) {
          $elm.addClass(setAnimationClass)
          if (this.$classFiveYearsOut.length) {
            this.animationTimeLine()
          }
          if ($elm.hasClass('GrowYourCareer')) {
            new LazyPicture()
          }
          if ($elm.hasClass('FiveYearsOut-item')) {
            let inter = setInterval(() => {
              if ($elm.index() === 0 || $elm.prev().hasClass(doneAnimationClass)) {
                clearInterval(inter)
                setTimeout(() => {
                  $elm.addClass(doneAnimationClass)
                }, 600)
              }
            }, 300)
          }
          if ($elm.hasClass('GlobalFooter')) {
            const urlImage = $elm.find('.GlobalFooter-Logo img').attr('data-original')
            $elm.find('.GlobalFooter-Logo img').attr('src', urlImage)
          }
        }
        return true
      })
    },
    animationTimeLine() {
      let fyoPosition = this.$classFiveYearsOut.offset().top;
      let lastItem = this.$classFiveYearsOut.find('.Set-animation').length - 1
      let itemLastest = this.$classFiveYearsOut.find('.AnimationItem')[lastItem]
      let numberSetItem = this.$classFiveYearsOut.find('.Set-animation').length
      let numberItem = this.$classFiveYearsOut.find('.FiveYearsOut-item').length
      if ($(itemLastest).hasClass('Set-animation')) {
        let heightImageItem = $(itemLastest).find('picture').innerHeight() / 2
        let positionItemLastest = $(itemLastest).offset().top
        let heightItemLastest = 0
        if (numberSetItem === numberItem) {
          heightItemLastest = $(itemLastest).innerHeight() + 100
        }
        let heightTimeLine = (positionItemLastest - fyoPosition + heightImageItem + heightItemLastest)
        this.$classFiveYearsOut.find('.FiveYearsOut-newLine').css('height', heightTimeLine)
      }
    }
  }, {
    create: function create() {
      new AnimationScroll();
    }
  });

module.exports = AnimationScroll;


// WEBPACK FOOTER //
// ./assets/components/AnimationScroll/AnimationScroll.js